// ===== GLOBAL HELPERS
// ==========================================
var global_helpers = {

    settings: {
        anchor_links: $('a[href^="#"]'),
        body: $('body'),
        header: $('header'),
        vimeo_iframes: $('iframe'),
        wrap_core_blocks: $('body.page-template-template-allow-core-blocks, body.location-template-default, body.page-template-default, body.post-type-archive-news, body.single-people'),
    },

    init: function () {
        // Wrap Core Gutenberg blocks separately
        if (this.settings.wrap_core_blocks.length) {
            this.wrapCoreBlocks();
        }
        // Update Vimeo src tracking parameter
        if (this.settings.vimeo_iframes.length) {
            this.vimeoTrackingUpdate();
        }
        this.bindUIActions();
    },

    bindUIActions: function () {
        // Standard Anchor Links
        global_helpers.settings.anchor_links.on('click', global_helpers.anchorLinks);
    },

    // Keycode detection for various accesibility interactions
    accessibilityButtons: function(e) {

        // 9 - Tab
        // 13 - Enter
        // 32 - Spacebar

        // Only allow interactions to fire on Enter or Spacebar keydown events
        if (e.keyCode) {
            if (e.keyCode == 13 || e.keyCode == 32) {
                e.preventDefault();
                return true;
            } else {
                return false;
            }
        }
        // Proceed as normal for mouse clicks
        return true;

    },

    // Smooth scroll to anchor linked items
    anchorLinks: function () {
        var link = $(this).attr('href');
        if (link.length) {
            var target = $(link).first();
            if (target.length) {
                var header = global_helpers.settings.header.outerHeight();
                var offset = target.offset().top - header;
                $('html, body').animate({
                    scrollTop: offset
                }, 1000);

                // Switch focus to state section scrolled to
                if (target.find('.state-link').length) {
                    target.find('.state-link').focus();
                }

                return false;
            }
        }
    },

    // Returns a function that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If 'immediate' is passed, trigger the function on the
    // leading edge, instead of the trailing.
    //
    // Use:  $(window).resize(global_helpers.debounce(function() { ...[your code here]... }, 500));
    // Source:  http://davidwalsh.name/javascript-debounce-function
    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args); }
        };
    },

    // Modify Vimeo iframe src if needed
    vimeoTrackingUpdate: function() {

        // Modify Vimeo iframe src if TrustArc is set to allow tracking
        // cmapi_cookie_privacy
        // permit_1|2|3_
        
        // If the TrustArc cookie has been set
        if (Cookies.get('cmapi_cookie_privacy')) {
            var trustarc = Cookies.get('cmapi_cookie_privacy');
            // If the permissions to track are true
            if (trustarc.includes('permit') && trustarc.includes('3')) {
                $('iframe').each(function() {
                    var iframe = $(this);
                    iframe.on('load', function() {
                        if ($(this).attr('src').length && $(this).attr('src').includes('dnt=1')) {
                            var link = $(this).attr('src').replace('dnt=1', 'dnt=0');
                            $(this).attr('src', link);
                        }
                    });
                });
            }
        }

    },

    // Some pages need to use a mix of ACF / WP Core blocks
    // Wrap non-ACF blocks to constrain the layout
    wrapCoreBlocks: function() {

        // All blocks
        var blocks = $('#main').children();
        // Blocks to wrap
        var blocks_to_wrap = $();
        // Wrapper element
        var wrapper = '<div class="gutenberg-wrapper bg-white"></div>';

        blocks.each(function(index) {

            var block = $(this);

            // Ignore certain elements
            if (block.is('[class^=block-], script, section')) {
                // Wrap blocks if there are any preceding this
                if (blocks_to_wrap.length) {
                    blocks_to_wrap.wrapAll(wrapper);
                    blocks_to_wrap = $();
                }
            } else {
                blocks_to_wrap = blocks_to_wrap.add(block);
            }

            // Last element
            if (index == (blocks.length - 1) && blocks_to_wrap.length) {
                blocks_to_wrap.wrapAll(wrapper);
            }

        });

    },

}
global_helpers.init();